import React from "react";
import { Div } from "atomize";
import { graphql } from "gatsby";
import Header from "../components/common/Header";

import SEO from "../components/seo";
import Layout from "../components/common/layout";
import Footer from "../components/common/Footer";
import ReviewModule from "../components/common/ReviewModule";
import BrandBuzzHero from "../components/brandbuzz/BrandBuzzHero";
import BuzzScaling from "../components/brandbuzz/BuzzScaling";
import BuzzArrows from "../components/brandbuzz/BuzzArrows";
import BuzzLaunch from "../components/brandbuzz/BuzzLaunch";
import BuzzMoon from "../components/brandbuzz/BuzzMoon";
import BuzzAnalytics from "../components/brandbuzz/BuzzAnalytics";
import SolutionsLearnMore from "../components/common/SolutionsLearnMore";
import SolutionsFooter from "../components/common/SolutionsFooter";
import BuzzSpark from "../components/brandbuzz/BuzzSpark";

const GenerateBrandBuzz = ({ data }) => {
  const content = JSON.parse(data.contentfulJson.json.json);

  return (
    <Layout>
      <SEO
        seo={data.contentfulJson.seo}
        url="https://trend.io/generate-brand-buzz"
      />
      <Header headerFixed={true} data={{ contentfulJson: data.headerJson }} />
      <BrandBuzzHero
        content={content.hero}
        form={
          data.contentfulGlobalConfig.generateBrandBuzzForm1
            .generateBrandBuzzForm1
        }
      />
      <BuzzScaling content={content.buzzScaling} />
      <BuzzArrows content={content.buzzArrows} />
      <Div m={{ t: { xs: "8rem", md: "16rem" } }}>
        <BuzzSpark content={content.buzzSpark} />
      </Div>
      <BuzzLaunch
        content={content.buzzLaunch}
        form={
          data.contentfulGlobalConfig.generateBrandBuzzForm2
            .generateBrandBuzzForm2
        }
      />
      <BuzzMoon content={content.buzzMoon} />
      <Div m={{ t: "6rem" }}>
        <ReviewModule content={content.reviewModule} />
      </Div>
      <BuzzAnalytics content={content.buzzAnalytics} />
      <Div m={{ t: { xs: "8.375rem", md: "15.75rem" } }}>
        <SolutionsLearnMore
          content={content.LearnMoreContent}
          form={
            data.contentfulGlobalConfig.generateBrandBuzzForm3
              .generateBrandBuzzForm3
          }
        />
      </Div>
      <Div m={{ t: { xs: "9.5rem", md: "15.75rem" } }}>
        <SolutionsFooter content={content.footerContent} />
      </Div>
      <Footer
        contentfulFooter={data.contentfulFooter}
        contentfulGlobalConfig={data.contentfulGlobalConfig}
      />
    </Layout>
  );
};

export const query = graphql`
  query SolutionPage4 {
    contentfulFooter(contentful_id: { eq: "5noUnCCOBDl8Is2Ppw2Nty" }) {
      solutions {
        label
        link
        isExternal
      }
      menu {
        label
        link
        isExternal
      }
      links {
        label
        link
        isExternal
      }
      instagramLink
      logoLink
    }

    contentfulGlobalConfig {
      footerForm {
        footerForm
      }
    }

    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }

    contentfulJson(contentful_id: { eq: "7GHt2r3iDEimIDWL1Th6EH" }) {
      json {
        json
      }

      seo {
        ...SeoFragment
      }
    }

    contentfulGlobalConfig {
      generateBrandBuzzForm1 {
        generateBrandBuzzForm1
      }
    }

    contentfulGlobalConfig {
      generateBrandBuzzForm2 {
        generateBrandBuzzForm2
      }
    }

    contentfulGlobalConfig {
      generateBrandBuzzForm3 {
        generateBrandBuzzForm3
      }
    }
  }
`;

export default GenerateBrandBuzz;
